import React, { Fragment } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Icon } from "@cdk-uip/react-icon";
import useValidation from "../../util/useValidation";
import {
  yearPattern,
  alphaNumericWithSpecialCharacterPattern,
  validUptoPattern
} from "../../constants/constants";
export const OtherQualificationForm = ({
  qualificationTypeID,
  certificationDetails,
  deleteCandidateQualificationDetails,
  handleOnChangeQualificationDetails,
  index
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  const handleOnChangeCertificationDetails = e => {
    handleOnChangeQualificationDetails(
      e,
      qualificationTypeID,
      certificationDetails
    );
  };
  return (
    <Fragment>
      <Row>
        <Col sm={11}>
          <h6> Certification Details</h6>
        </Col>
        <Col sm={1} className="text-right">
          <Icon
            onClick={() =>
              deleteCandidateQualificationDetails(certificationDetails.id)
            }
          >
            delete
          </Icon>
        </Col>
      </Row>
      <Form.Group as={Row} controlId="name">
        <Form.Label column sm={2}>
          Course/Certification*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Course Name or Certification"
            type="text"
            name="degree"
            value={certificationDetails.degree}
            onChange={handleOnChangeCertificationDetails}
            autoFocus
            onBlur={handOnBlurInput}
            isInvalid={errors.degree}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.degree && (
            <Form.Control.Feedback type="invalid">
              {errors.degree.type === "required" &&
                "Course/Certification is required"}
              {errors.degree.type === "pattern" &&
                "Invalid characters entered for Course/Certification"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="specialization">
        <Form.Label column sm={2}>
          Specialization*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Specialization"
            type="text"
            name="specialization"
            value={certificationDetails.specialization}
            onChange={handleOnChangeCertificationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.specialization}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.specialization && (
            <Form.Control.Feedback type="invalid">
              {errors.specialization.type === "required" &&
                "Specialization is required"}
              {errors.specialization.type === "pattern" &&
                "Invalid characters entered for Specialization"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="yearValidity">
        <Form.Label column sm={2}>
          Completed Year*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            required
            placeholder="Year of Completion"
            type="text"
            name="completionYear"
            value={certificationDetails.completionYear}
            onChange={handleOnChangeCertificationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.completionYear}
            pattern={yearPattern}
          />
          {errors.completionYear && (
            <Form.Control.Feedback type="invalid">
              {errors.completionYear.type === "required" &&
                "Completed Year is required"}
              {errors.completionYear.type === "pattern" &&
                "Please enter valid Year"}
            </Form.Control.Feedback>
          )}{" "}
        </Col>
        <Form.Label column sm={2} className="text-right">
          Valid Upto
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            placeholder="Valid Upto"
            type="text"
            name="courseValidUpTo"
            value={certificationDetails.courseValidUpTo}
            onChange={handleOnChangeCertificationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.courseValidUpTo}
            pattern={validUptoPattern}
          />
          {errors.courseValidUpTo && (
            <Form.Control.Feedback type="invalid">
              {errors.courseValidUpTo.type === "pattern" &&
                "Invalid characters entered for Valid Upto"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="institute">
        <Form.Label column sm={2}>
          Institute*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Institute/Platform"
            type="text"
            name="college"
            value={certificationDetails.college}
            onChange={handleOnChangeCertificationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.college}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.college && (
            <Form.Control.Feedback type="invalid">
              {errors.college.type === "required" && "Institute is required"}
              {errors.college.type === "pattern" &&
                "Invalid characters entered for Institute"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
    </Fragment>
  );
};
export default OtherQualificationForm;
